import {
  DeleteOutlined,
  DownOutlined,
  InboxOutlined,
  RightOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import {
  Avatar,
  Badge,
  Button,
  Card,
  Checkbox,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Input,
  Pagination,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  theme,
  DatePicker,
  Tooltip,
} from 'antd';
import React, { useEffect, useState } from 'react';
import AdminSearchBarHeader from '../component/AdminSearchBarHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import routes from '../../../controller/Routes';
import { reverse } from 'named-urls';
import CandidateDelete from '../component/modal/CandidateDelete';
import moment from 'moment';
import CandidateReviewModal from '../component/modal/CandidateReviewModal';
import dayjs from 'dayjs';
import axios from 'axios';
import { getCandidate } from '../../../controller/api/candidateServices';
import { getAdminDetail } from '../../../controller/localStroageHandler';
import CandidateTestTable from './CandidateTestTable';
import { getResume } from '../../../controller/api/globalServices';
const { Option } = Select;
const Candidate = () => {
  const { RangePicker } = DatePicker;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [cardOpen, setCardOpen] = useState('');
  const [filterOpen, setFilterOpen] = useState(false);
  const location = useLocation();
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({
    latest: true,
    test: [],
    sort: 'hightolow',
    start_date: null,
    end_date: null,
    current: 1,
    pageSize: 10,
    location: [],
    experience: [],
  });
  const [search, setSearch] = useState('');
  const [candidateDeleteModalOpen, setCandidateDeleteModalOpen] =
    useState(false);
  const [candidateDeleteid, setCandidateDeleteId] = useState(null);
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const filterObject = {};
    if (queryParams && queryParams.toString()) {
      for (let [key, value] of queryParams.entries()) {
        if (key == 'latest') {
          filterObject[key] = value == 'true' ? true : false;
        } else if (key == 'start_date') {
          filterObject[key] = value == 'null' ? null : value;
        } else if (key == 'end_date') {
          filterObject[key] = value == 'null' ? null : value;
        } else {
          filterObject[key] = value.includes(',') ? value.split(',') : value;
        }
      }
      setFilter({
        ...filterObject,
        test: filterObject?.test == '' ? [] : filterObject?.test,
        location: filterObject?.location == '' ? [] : filterObject?.location,
        experience:
          filterObject?.experience == '' ? [] : filterObject?.experience,
      });
    }
  }, []);

  useEffect(() => {
    const queryString = new URLSearchParams(filter).toString();
    navigate(`${routes.admin.dashboard.candidates}${queryString}`);
  }, [filter]);
  const [testFilterList, setTestFilterList] = useState([]);
  // useEffect(() => {
  //   getTestName()
  //     .then((res) => {
  //       console.log(res, 'ffmlfmlf');
  //       setTestFilterList(res?.data);
  //     })
  //     .catch((err) => console.log('err ====> ', err));
  // }, []);

  const [candidate, setcandidate] = useState([]);
  const [openCandidateReviewMOdal, setOpenCandidateReviewModal] =
    useState(false);
  const [candidateResponseData, setcandidateResponseData] = useState(null);
  const userDetail = getAdminDetail();
  useEffect(() => {
    candidateData();
  }, []);
  // const candidateData = () => {
  // const tableparams = {
  //   pagination: {
  //     current: filter.current,
  //     pageSize: filter.pageSize,
  //   },
  //   filter: {
  //     latest: filter.latest,
  //     test: filter.test,
  //     location: filter.location,
  //     experience: filter.experience,
  //     sort: filter.sort,
  //     start_date: filter?.start_date,
  //     end_date: filter?.end_date,
  //   },
  // };
  // setLoading(true);
  // getCandidate({ ...tableparams, search: search })
  //   .then((res) => {
  //     setTotal(res?.data?.count);
  //     setcandidate(res?.data?.results);
  //     setLoading(false);
  //   })
  //   .catch((err) => console.log(err, 'lfmflmf'))
  //   .finally(() => {
  //     setLoading(false);
  //   });
  // };

  const candidateData = () => {
    getCandidate({ id: userDetail?.organization_id?._id }).then(res => {
      setcandidate(res?.data?.data)
    }).catch(err => { console.log("err ===>", err) })
  }
  const [city, setCity] = useState([]);
  useEffect(() => {
    axios
      .get('https://api.countrystatecity.in/v1/countries/IN/`cities`', {
        headers: {
          'X-CSCAPI-KEY':
            'aE16ZUEzQ1dqQzlMbkpIY0ZIQnNSZHdnWEM5dnBpeENFUWd3bEJjRQ==',
        },
      })
      .then((res) => {
        setCity(res?.data);
      })
      .catch((err) => {
        console.log(err, 'errr');
      });
  }, []);
  let experienceOptions = [
    { year: '0-1', id: '0-1' },
    { year: '1-2', id: '1-2' },
    { year: '2-3', id: '2-3' },
    { year: '3-4', id: '3-4' },
    { year: '4-5', id: '4-5' },
    { year: '5-6', id: '5-6' },
    { year: '6-7', id: '6-7' },
    { year: '7-8', id: '7-8' },
    { year: '8-9', id: '8-9' },
    { year: '9-10', id: '9-10' },
  ];
  return (
    <>
      <div className='w-100 h-100 p-4 bg-light overflow-y-auto'>
        <AdminSearchBarHeader search={search} setSearch={setSearch} />
        <Row align={'middle'} className='mt-4'>
          <Col span={12} className='fs-6 fw-semibold'>
            All Candidates
          </Col>
          <Col
            span={12}
            className='d-flex fs-6 fw-semibold justify-content-end gap-2 align-items-center'
          >
            Filter By :
            <Dropdown
              open={filterOpen}
              menu={{
                items: [
                  {
                    key: 1,
                    label: (
                      <Checkbox
                        checked={filter.latest}
                        onChange={(val) =>
                          setFilter({ ...filter, latest: val.target.checked })
                        }
                      >
                        Latest
                      </Checkbox>
                    ),
                  },
                  {
                    key: 2,
                    label: (
                      <Row gutter={[8, 8]}>
                        <Col span={24}>
                          <span className='fw-semibold'>Test</span>
                        </Col>
                        <Col span={24}>
                          <Select
                            className='w-100'
                            mode='multiple'
                            value={filter.test}
                            onChange={(val) =>
                              setFilter({ ...filter, test: val })
                            }
                            allowClear
                          >
                            {testFilterList?.map((val, index) => {
                              return (
                                <Option value={val?.name}>{val?.name}</Option>
                              );
                            })}
                          </Select>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    key: 3,
                    label: (
                      <Row gutter={[8, 8]}>
                        <Col span={24}>
                          <span className='fw-semibold'>Sort</span>
                        </Col>
                        <Col span={24}>
                          <Radio.Group
                            className='w-100'
                            value={filter.sort}
                            onChange={(e) =>
                              setFilter({ ...filter, sort: e.target.value })
                            }
                          >
                            <Space direction='vertical'>
                              <Radio value={'hightolow'}>High To Low</Radio>
                              <Radio value={'lowtohigh'}>Low To High</Radio>
                            </Space>
                          </Radio.Group>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    key: 4,
                    label: (
                      <Row gutter={[8, 8]}>
                        <Col span={24}>
                          <span className='fw-semibold'>Location</span>
                        </Col>
                        <Col span={24}>
                          <Select
                            className='w-100'
                            mode='multiple'
                            value={filter.location}
                            onChange={(val) =>
                              setFilter({ ...filter, location: val })
                            }
                            allowClear
                          >
                            {city?.map((val, index) => {
                              return (
                                <Option value={val?.name}>{val?.name}</Option>
                              );
                            })}
                          </Select>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    key: 5,
                    label: (
                      <Row gutter={[8, 8]}>
                        <Col span={24}>
                          <span className='fw-semibold'>Experience</span>
                        </Col>
                        <Col span={24}>
                          <Select
                            className='w-100'
                            mode='multiple'
                            value={filter.experience}
                            onChange={(val) =>
                              setFilter({ ...filter, experience: val })
                            }
                            allowClear
                          >
                            {experienceOptions?.map((val, index) => {
                              return (
                                <Option value={val?.id}>
                                  {val?.year} year
                                </Option>
                              );
                            })}
                          </Select>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    key: 6,
                    label: (
                      <Row gutter={[8, 8]}>
                        <Col span={24}>
                          <span className='fw-semibold'>Sort By Date</span>
                        </Col>
                        <Col span={24}>
                          <RangePicker
                            className='w-100'
                            format={'YYYY-MM-DD'}
                            value={
                              filter.start_date != null &&
                                filter.end_date != null
                                ? [
                                  dayjs(filter.start_date),
                                  dayjs(filter.end_date),
                                ]
                                : null
                            }
                            onChange={(dateval) => {
                              let filterData = { ...filter };
                              if (dateval && dateval.length === 2) {
                                filterData.start_date = dayjs(
                                  dateval[0]
                                ).format('YYYY-MM-DD');
                                filterData.end_date = dayjs(dateval[1]).format(
                                  'YYYY-MM-DD'
                                );
                                setFilter(filterData);
                              } else {
                                filterData.start_date = null;
                                filterData.end_date = null;
                                setFilter(filterData);
                              }
                            }}
                          />
                        </Col>
                      </Row>
                    ),
                  },
                ],
              }}
            >
              {/* <RangePicker /> */}
              <div
                className='bg-white rounded-5 w-50 fw-normal text-muted border-color border d-flex justify-content-between'
                style={{
                  fontSize: '14px',
                  paddingLeft: '15px',
                  paddingRight: '12px',
                  paddingTop: '5px',
                  paddingBottom: '5px',
                  cursor: 'pointer',
                }}
                onClick={() => setFilterOpen(!filterOpen)}
              >
                latest,test
                <DownOutlined />
              </div>
            </Dropdown>
          </Col>
        </Row>
        <Spin spinning={loading}>
          {candidate?.length ? (
            <Row gutter={[12, 15]} align={'middle'} className='mt-4'>
              {candidate?.map((val, index) => {
                return (
                  <Col span={24} key={index}>
                    <Card
                      className='candidate-card'
                      title={
                        <Row gutter={[12, 15]}>
                          <Col lg={8} md={8} sm={8} xs={12}>
                            <div className='d-flex gap-2 align-items-center'>
                              <Avatar
                                style={{
                                  backgroundColor: '#b2d8a7',
                                  verticalAlign: 'middle',
                                }}
                                size='large'
                              >
                                {val?.firstName[0]} {val?.lastName[0]}
                              </Avatar>
                              <div className='d-flex flex-column'>
                                <span className='text-black fw-semibold'>
                                  {val?.firstName} {val?.lastName}
                                </span>
                              </div>
                            </div>
                          </Col>
                          <Col lg={4} md={4} sm={4} xs={3}>
                            <div className='d-flex flex-column'>
                              <span className='text-black fw-semibold'>
                                PhoneNo
                              </span>
                              <span className='text-muted'>
                                {val?.phoneNo}
                              </span>
                            </div>
                          </Col>
                          <Col lg={4} md={4} sm={4} xs={3}>
                            <div className='d-flex flex-column d-xs-none'>
                              <span className='text-black fw-semibold'>
                                Email ID
                              </span>
                              <span className='text-muted text-truncate'>
                                {val?.email}
                              </span>
                            </div>
                          </Col>
                          <Col lg={4} md={4} sm={4} xs={3}>
                            <div className='d-flex flex-column d-xs-none'>
                              <span className='text-black fw-semibold'>
                                Experience
                              </span>
                              <span className='text-muted'>
                                {val?.experience || '-'}
                              </span>
                            </div>
                          </Col>
                          <Col lg={4} md={4} sm={4} xs={3}>
                            <div className='d-flex flex-column d-xs-none'>
                              <span className='text-black fw-semibold'>
                                Location
                              </span>
                              <span className='text-muted'>
                                {val?.location || '-'}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      }
                      extra={
                        <div className='d-flex gap-3'>
                          {cardOpen !== val ? (
                            <RightOutlined onClick={() => setCardOpen(val)} />
                          ) : (
                            <DownOutlined onClick={() => setCardOpen('')} />
                          )}
                          <DeleteOutlined
                            onClick={() => {
                              setCandidateDeleteId(val.id);
                              setCandidateDeleteModalOpen(true);
                            }}
                          />
                        </div>
                      }
                    >
                      <div className='d-flex flex-column gap-2'>
                        {val == cardOpen && (
                          <>
                            <div className='d-flex justify-content-between align-items-center fw-semibold'>
                              <span className='text-black'>Email ID</span>
                              <span className='text-muted'>{val?.email}</span>
                            </div>
                            <div className='d-flex justify-content-between align-items-center fw-semibold'>
                              <span className='text-black'>Phone No.</span>
                              <span className='text-muted'>{val?.phoneNo}</span>
                            </div>
                            <div className='d-flex justify-content-between align-items-center fw-semibold'>
                              <span className='text-black'>Experience</span>
                              <span className='text-muted'>
                                {val?.experience || '-'}
                              </span>
                            </div>
                            <div className='d-flex justify-content-between align-items-center fw-semibold'>
                              <span className='text-black'>Intitude Name</span>
                              <span className='text-muted'>
                                {val?.instituteName}{' '}
                              </span>
                            </div>
                            <div className='d-flex justify-content-between align-items-center fw-semibold'>
                              <span className='text-black'>Location</span>
                              <span className='text-muted'>
                                {val?.location || '-'}
                              </span>
                            </div>
                            <div className='d-flex flex-column fw-semibold'>
                              <span className='text-black'>Key Skills</span>
                              <span className='d-flex flex-wrap gap-2'>
                                {val?.keySkills?.map((item, index) => {
                                  return (
                                    <span
                                      class='badge skill-bg-color text-muted'
                                      key={index}
                                    >
                                      {item.name}
                                    </span>
                                  );
                                })}
                              </span>
                            </div>
                            <CandidateTestTable candidateData={val} setOpenCandidateReviewModal={setOpenCandidateReviewModal}
                              setcandidateResponseData={setcandidateResponseData} />
                          </>
                        )}
                        <div className='w-100 d-flex justify-content-between align-items-center'>
                          <div className='d-flex flex-column'>
                            {/* <span className='text-black fw-semibold'>
                              Submission Date
                            </span>
                            <span className='text-muted'>
                              {val?.end_time
                                ? moment(val?.end_time).format('MM/DD/YYYY')
                                : '-'}
                            </span> */}
                          </div>
                          <div className='d-flex gap-3 flex-wrap justify-content-end'>
                          <Button
                                type='text'
                                className='text-color-custom fs-6 fw-semibold d-flex justify-content-center align-items-center custom-hover-btn'
                                onClick={()=>val?.resumeUrl&&getResume(val?.resumeUrl)}
                              >
                                Resume
                              </Button>
                            <Button
                              type='default'
                              className='text-color-custom fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
                              onClick={(e) => {
                                navigate(
                                  reverse(
                                    routes?.admin?.dashboard?.cadidateView,
                                    { id: val?._id }
                                  )
                                );
                              }}
                            >
                              Profile
                            </Button>
                            {/* <Button
                              type='default'
                              className='text-color-custom fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setOpenCandidateReviewModal(true);
                                setcandidateResponseData(val?.user_response);
                              }}
                            >
                              Review Test
                            </Button> */}
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Col>
                );
              })}
              <Pagination
                className='w-100 d-flex justify-content-center'
                total={total}
                current={filter.current}
                pageSize={filter.pageSize}
                showSizeChanger={true}
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} of ${total}`
                }
                onChange={(current, pageSize) =>
                  setFilter({ ...filter, current: current, pageSize })
                }
              />
            </Row>
          ) : (
            <Row
              gutter={[12, 15]}
              align={'middle'}
              justify={'center'}
              className=' d-flex flex-column mt-5 w-100'
            >
              <InboxOutlined className='empty-inbox-icon' />
              <span className='text-muted fw-medium'>No Data</span>
            </Row>
          )}
        </Spin>
        {candidateDeleteModalOpen && (
          <CandidateDelete
            candidateDeleteModalOpen={candidateDeleteModalOpen}
            setCandidateDeleteModalOpen={setCandidateDeleteModalOpen}
          />
        )}
      </div>
      {openCandidateReviewMOdal && (
        <CandidateReviewModal
          openCandidateReviewMOdal={openCandidateReviewMOdal}
          setOpenCandidateReviewModal={setOpenCandidateReviewModal}
          candidateResponseData={candidateResponseData}
          setcandidateResponseData={setcandidateResponseData}
        />
      )}
    </>
  );
};

export default Candidate;
